import * as React from 'react'
// libs
import styled from 'styled-components'
// components
import { DrawerModal } from 'components/UI'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { Modals } from 'constants/index'
// context
import { PlanEditPageContext } from 'containers/Plan/Edit/layers/API'
// themes
import { CloseIcon } from 'components/UI/Icons'
// view components
import { Header } from 'components/Modals/PlanItems/styles'
import { Scrollbar as ActivitiesScrollbar } from 'components/Modals/PlanItems/components/ActivitiesList/components/ActivitiesContent'
import ActivitiesListContainer from 'containers/Activities/components/ActivitiesList'
// graphql
import { PLAN_ACTIVITIES_LIST_QUERY } from 'graphql/plan/queries'
// types
import { LogEntityTypes } from 'types/graphql'

export const Wrapper = styled('div')`
  height: calc(100% - 64px);

  > div {
    height: 100%;
  }

  ${ActivitiesScrollbar} {
    height: calc(100% - 110px);
  }
`

const PAPER_PROPS = {
  style: {
    top: 0,
    height: '100%',
    width: '600px',
    overflow: 'hidden'
  }
}

const PlanActivitiesModal: React.FC = () => {
  const { plan } = React.useContext(PlanEditPageContext)

  const {
    hideModal,
    modalData: { isOpen }
  } = useModalData({ modalType: Modals.PLAN_ACTIVITIES_MODAL })

  return (
    <DrawerModal width={'600px'} isOpen={isOpen} hideModal={hideModal} PaperProps={PAPER_PROPS}>
      <Header>
        <span>Activity</span>
        <CloseIcon onClick={hideModal} />
      </Header>
      <Wrapper>
        <ActivitiesListContainer
          entity={{ ...plan, entityType: LogEntityTypes.Plan }}
          query={PLAN_ACTIVITIES_LIST_QUERY}
          variables={{
            filter: { entityId: plan.id }
          }}
        />
      </Wrapper>
    </DrawerModal>
  )
}

export default PlanActivitiesModal
